export const MIN_PASSWORD_LENGTH = 8;

export const PASSWORD_REQUIREMENTS = {
  MIN_LENGTH: `Password must have at least ${MIN_PASSWORD_LENGTH} characters`,
  LOWERCASE: 'Password must have lower case letters',
  UPPERCASE: 'Password must have upper case letters',
  NUMBERS: 'Password must have numbers',
  SPECIAL_CHARS: 'Password must have special characters'
} as const;

/**
 * Validates a password against common security requirements
 * @param password - The password string to validate
 * @returns Array of error messages for failed validations, empty array if valid
 */
export function validatePassword(password: string): string[] {
  const requirements: string[] = [];

  if (password.length < MIN_PASSWORD_LENGTH) {
    requirements.push(PASSWORD_REQUIREMENTS.MIN_LENGTH);
  }

  if (!/[a-z]/.test(password)) {
    requirements.push(PASSWORD_REQUIREMENTS.LOWERCASE);
  }

  if (!/[A-Z]/.test(password)) {
    requirements.push(PASSWORD_REQUIREMENTS.UPPERCASE);
  }

  if (!/[0-9]/.test(password)) {
    requirements.push(PASSWORD_REQUIREMENTS.NUMBERS);
  }

  if (!/[!@#$%^&*(),.?":{}|<>\-_+=]/.test(password)) {
    requirements.push(PASSWORD_REQUIREMENTS.SPECIAL_CHARS);
  }

  return requirements;
}
